import React, { useEffect, useState } from 'react';
import VideoCard from '../components/Card/VideoCard';
import DigitalCard from '../components/Card/DigitalCard';
import useApi from '../hooks/useApi';
import { useInView } from 'react-intersection-observer';
import { useSetRecoilState } from 'recoil';
import { loadingSpinnerState } from '../recoil/loadingSpinner/loadingSpinnerAtom';
import { useNavigate } from 'react-router-dom';
import PRODUCT_TYPES from '../constants/productTypes';

const ProductList = ({ isLogin }) => {
  const [activeTab, setActiveTab] = useState('video'); // 기획 default: 'videos' tab
  const [videoProducts, setVideoProducts] = useState([]);
  const [digitalProducts, setDigitalProducts] = useState([]);
  const [videoNextKey, setVideoNextKey] = useState(0);
  const [digitalNextKey, setDigitalNextKey] = useState(0);
  const setIsLoading = useSetRecoilState(loadingSpinnerState);

  const [ref, inView] = useInView();
  const api = useApi();
  const navigate = useNavigate();
  const fetchProductList = async (product_type) => {
    setIsLoading(true);

    let key_param = '';
    if (product_type === PRODUCT_TYPES.VIDEO && videoNextKey !== null && videoNextKey !== 0) {
      key_param = `&next_key=${videoNextKey}`;
    } else if (product_type === PRODUCT_TYPES.DIGITAL && digitalNextKey !== null && digitalNextKey !== 0) {
      key_param = `&next_key=${digitalNextKey}`;
    }

    try {
      const size = 12; // 1회 호출량
      const response = await api.get(`mubeat_live/product/list?product_type=${product_type}${key_param}&size=${size}`);
      const newProducts = response?.data?.products;

      if (newProducts && newProducts.length > 0) {
        if (product_type === PRODUCT_TYPES.VIDEO) {
          let combinedProducts = [...videoProducts, ...newProducts];
          // 중복 데이터 제거
          const uniqueProducts = combinedProducts.filter(
            (product, index, self) => index === self.findIndex((t) => t.id === product.id),
          );

          setVideoProducts(uniqueProducts);
          const newNextKey = response?.data?.next_key;
          if (videoNextKey !== null) {
            setVideoNextKey(newNextKey);
          }
        } else {
          let combinedProducts = [...digitalProducts, ...newProducts];
          // 중복 데이터 제거
          const uniqueProducts = combinedProducts.filter(
            (product, index, self) => index === self.findIndex((t) => t.id === product.id),
          );
          setDigitalProducts(uniqueProducts);
          const newNextKey = response?.data?.next_key;
          if (digitalNextKey !== null) {
            setDigitalNextKey(newNextKey);
          }
        }
      }
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_BAD_RESPONSE') {
        navigate('/error');
      } else {
        console.log(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (videoNextKey !== null || digitalNextKey !== null) {
      fetchProductList(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    // inView: 스크롤이 하단에 닿았을 때 true
    if (inView) {
      if (videoNextKey) fetchProductList('video');
      if (digitalNextKey) fetchProductList('digital');
    }
  }, [inView]);

  return (
    <div className={'product-list-all-wrapper'}>
      <div className={'layout-inner'}>
        <div className={'product-list-wrapper'}>
          <div className={'product-tab-wrapper'}>
            <ul className={'product-tab-group'}>
              <li
                className={`product-tab-list ${activeTab === 'video' ? 'is-active' : ''}`}
                onClick={() => {
                  handleTabClick('video');
                }}
              >
                <button type={'button'} className={'button-default product-tab-button'}>
                  Videos
                </button>
              </li>
              <li
                className={`product-tab-list ${activeTab === 'digital' ? 'is-active' : ''}`}
                onClick={() => {
                  handleTabClick('digital');
                }}
              >
                <button type={'button'} className={'button-default product-tab-button'}>
                  Digital Products
                </button>
              </li>
            </ul>
          </div>
          <div className='product-content-wrapper'>
            <>
              {activeTab === 'video'
                ? videoProducts?.map((item) => <VideoCard key={item.id} item={item} isLogin={isLogin} />)
                : null}
              {activeTab === 'digital'
                ? digitalProducts?.map((item) => <DigitalCard key={item.id} item={item} />)
                : null}
            </>
          </div>
        </div>
      </div>
      <span ref={ref} style={{ opacity: 0 }} />
    </div>
  );
};

export default ProductList;
